export default "__VITE_ASSET__BJ9mZPAO__"